import { render, staticRenderFns } from "./KategoriListe.vue?vue&type=template&id=72eaa194&scoped=true&"
import script from "./KategoriListe.vue?vue&type=script&lang=js&"
export * from "./KategoriListe.vue?vue&type=script&lang=js&"
import style0 from "./KategoriListe.vue?vue&type=style&index=0&id=72eaa194&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72eaa194",
  null
  
)

export default component.exports